import CollapsibleSection from "ds/components/CollapsibleSection";
import Box from "ds/components/Box";

import LaunchPadExploreNextItem from "./Item";
import { EXPLORE_NEXT_FEATURES } from "./constants";

const LaunchPadExploreNext = () => {
  return (
    <CollapsibleSection
      title="Explore next"
      ariaLevel={2}
      ariaLabel="Explore next"
      initialIsCollapsed={false}
    >
      <Box grid gridTemplate="1fr 1fr 1fr" gap="large">
        {EXPLORE_NEXT_FEATURES.map((feature) => (
          <LaunchPadExploreNextItem key={feature.title} {...feature} />
        ))}
      </Box>
    </CollapsibleSection>
  );
};

export default LaunchPadExploreNext;
